module.exports = __webpack_public_path__ + "img/support-subject.079034fe.svg";